import { render, staticRenderFns } from "./LogoTxt.vue?vue&type=template&id=7e505700&scoped=true&"
import script from "./LogoTxt.vue?vue&type=script&lang=js&"
export * from "./LogoTxt.vue?vue&type=script&lang=js&"
import style0 from "./LogoTxt.vue?vue&type=style&index=0&id=7e505700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e505700",
  null
  
)

export default component.exports